/**
 * Tempo limite por fase e categorias de fases no kanban de oportunidades.
 */
(function () {
    const routes = {
        tempoLimiteShow: (faseId) => siteUrl(`/painel/oportunidades-fases/${faseId}/tempo-limite`),
        tempoLimiteStore: () => siteUrl("/painel/oportunidades-fases/tempo-limite"),
        tempoLimiteDestroy: (faseId) =>
            siteUrl(`/painel/oportunidades-fases/${faseId}/tempo-limite`),
        categoriasIndex: () => siteUrl("/painel/oportunidades-fases-categorias"),
        categoriasStore: () => siteUrl("/painel/oportunidades-fases-categorias"),
        categoriasUpdate: (id) => siteUrl(`/painel/oportunidades-fases-categorias/${id}`),
        categoriasDestroy: (id) => siteUrl(`/painel/oportunidades-fases-categorias/${id}`),
    };

    function escapeHtml(value) {
        return String(value == null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function pipelineIdAtual() {
        const fromSelect = $('select[name="pipeline_id"], input[name="pipeline_id"]').first().val();
        if (fromSelect) {
            return fromSelect;
        }

        return $("#kanban").data("pipeline") || "";
    }

    function csrfToken() {
        return $('meta[name="csrf-token"]').attr("content") || $('input[name="_token"]').val();
    }

    function toast(message, type) {
        const tipo = type || "success";
        if (tipo === "danger" && typeof window.showToastDanger === "function") {
            window.showToastDanger(document, message);
            return;
        }
        if (tipo === "warning" && typeof window.showToastWarning === "function") {
            window.showToastWarning(document, message);
            return;
        }
        if (typeof window.showToastSuccess === "function") {
            window.showToastSuccess(document, message);
        }
    }

    function abrirModalTempoLimite(faseId, faseNome) {
        const $modal = $("#modalTempoLimiteFase");
        $modal.find("#js-tempo-limite-fase-id").val(faseId);
        $modal.find(".js-tempo-limite-fase-nome").text(faseNome || "");
        $modal.find(".js-tempo-limite-dias, .js-tempo-limite-horas, .js-tempo-limite-minutos").val(0);
        $modal.find(".js-tempo-limite-atual").addClass("d-none").text("");
        $modal.find(".js-remover-tempo-limite-fase").addClass("d-none");

        $.get(routes.tempoLimiteShow(faseId))
            .done(function (response) {
                if (response.error) {
                    toast(response.message || "Erro ao carregar tempo limite.", "danger");
                    return;
                }

                const data = response.data || {};
                $modal.find(".js-tempo-limite-dias").val(data.dias || 0);
                $modal.find(".js-tempo-limite-horas").val(data.horas || 0);
                $modal.find(".js-tempo-limite-minutos").val(data.minutos || 0);

                if (data.configurado) {
                    $modal
                        .find(".js-tempo-limite-atual")
                        .removeClass("d-none")
                        .text(
                            `Limite atual: ${data.dias || 0}d ${data.horas || 0}h ${data.minutos || 0}min`
                        );
                    $modal.find(".js-remover-tempo-limite-fase").removeClass("d-none");
                }

                $modal.modal("show");
            })
            .fail(function () {
                toast("Erro ao carregar tempo limite da fase.", "danger");
            });
    }

    function salvarTempoLimite(event) {
        event.preventDefault();
        const $form = $("#js-form-tempo-limite-fase");

        $.ajax({
            url: routes.tempoLimiteStore(),
            method: "POST",
            data: {
                _token: csrfToken(),
                fase_id: $form.find("#js-tempo-limite-fase-id").val(),
                dias: $form.find(".js-tempo-limite-dias").val(),
                horas: $form.find(".js-tempo-limite-horas").val(),
                minutos: $form.find(".js-tempo-limite-minutos").val(),
            },
        })
            .done(function (response) {
                if (response.error) {
                    toast(response.message || "Erro ao salvar.", "danger");
                    return;
                }
                toast(response.message || "Tempo limite salvo.");
                $("#modalTempoLimiteFase").modal("hide");
            })
            .fail(function (xhr) {
                const message =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Erro ao salvar tempo limite.";
                toast(message, "danger");
            });
    }

    function abrirModalRemoverTempoLimite() {
        const faseId = $("#js-tempo-limite-fase-id").val();
        if (!faseId) {
            return;
        }

        $("#modalConfirmaExcluirTempoLimiteFase").modal({
            backdrop: false,
            keyboard: true,
            show: true,
        });
    }

    function removerTempoLimite() {
        const faseId = $("#js-tempo-limite-fase-id").val();
        if (!faseId) {
            return;
        }

        $("#modalConfirmaExcluirTempoLimiteFase").modal("hide");

        $.ajax({
            url: routes.tempoLimiteDestroy(faseId),
            method: "POST",
            data: {
                _token: csrfToken(),
                _method: "DELETE",
            },
        })
            .done(function (response) {
                if (response.error) {
                    toast(response.message || "Erro ao remover.", "danger");
                    return;
                }
                toast(response.message || "Tempo limite removido.");
                $("#modalTempoLimiteFase").modal("hide");
            })
            .fail(function () {
                toast("Erro ao remover tempo limite.", "danger");
            });
    }

    function renderFasesCheckboxes(fases, selecionadas) {
        const selected = (selecionadas || []).map(String);
        const $container = $(".js-categoria-fases-checkboxes");
        $container.empty();

        if (!fases || !fases.length) {
            $container.append('<p class="small text-muted mb-0">Nenhuma fase neste pipeline.</p>');
            return;
        }

        fases.forEach(function (fase) {
            const checked = selected.indexOf(String(fase.id)) !== -1 ? "checked" : "";
            $container.append(
                `<div class="custom-control custom-checkbox mb-1">
                    <input type="checkbox" class="custom-control-input js-categoria-fase-check"
                        id="cat-fase-${fase.id}" value="${fase.id}" ${checked}>
                    <label class="custom-control-label" for="cat-fase-${fase.id}">${escapeHtml(fase.nome)}</label>
                </div>`
            );
        });
    }

    function renderCategoriasLista(categorias) {
        const $lista = $(".js-categorias-lista");
        $lista.empty();

        if (!categorias || !categorias.length) {
            $lista.append(
                `<div class="oportunidade-categoria-lista__vazia">
                    <i class="fas fa-layer-group"></i>
                    <span>Nenhuma categoria cadastrada neste pipeline.</span>
                </div>`
            );
            return;
        }

        categorias.forEach(function (categoria) {
            const fases = categoria.fases || [];
            const fasesHtml = fases.length
                ? fases
                      .map(function (fase) {
                          const cor = escapeHtml(fase.cor || "#6c757d");
                          return `<span class="oportunidade-categoria-card__fase" title="${escapeHtml(fase.nome)}">
                                <span class="oportunidade-categoria-card__fase-dot" style="background-color:${cor};"></span>
                                ${escapeHtml(fase.nome)}
                            </span>`;
                      })
                      .join("")
                : '<span class="oportunidade-categoria-card__sem-fase">Sem fases vinculadas</span>';

            const limiteHtml = categoria.tempo_limite_formatado
                ? `<span class="oportunidade-categoria-card__limite oportunidade-categoria-card__limite--definido">
                        <i class="far fa-clock"></i>
                        ${escapeHtml(categoria.tempo_limite_formatado)}
                   </span>`
                : `<span class="oportunidade-categoria-card__limite oportunidade-categoria-card__limite--vazio">
                        <i class="far fa-clock"></i>
                        Sem limite
                   </span>`;

            $lista.append(
                `<div class="oportunidade-categoria-card js-categoria-item" data-id="${categoria.id}">
                    <div class="oportunidade-categoria-card__header">
                        <div class="oportunidade-categoria-card__titulo">
                            <span class="oportunidade-categoria-card__icone">
                                <i class="fas fa-layer-group"></i>
                            </span>
                            <strong>${escapeHtml(categoria.nome)}</strong>
                        </div>
                        <div class="oportunidade-categoria-card__direita">
                            ${limiteHtml}
                            <div class="oportunidade-categoria-card__acoes">
                                <button type="button" class="btn btn-sm oportunidade-categoria-card__btn js-editar-categoria"
                                    title="Editar categoria"
                                    data-id="${categoria.id}"
                                    data-nome="${escapeHtml(categoria.nome)}"
                                    data-fase-ids='${JSON.stringify(categoria.fase_ids || [])}'>
                                    <i class="fas fa-pen"></i>
                                </button>
                                <button type="button" class="btn btn-sm oportunidade-categoria-card__btn oportunidade-categoria-card__btn--danger js-excluir-categoria"
                                    title="Excluir categoria"
                                    data-id="${categoria.id}"
                                    data-nome="${escapeHtml(categoria.nome)}">
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="oportunidade-categoria-card__fases">${fasesHtml}</div>
                </div>`
            );
        });
    }

    function resetFormCategoria() {
        $("#js-categoria-id").val("");
        $(".js-categoria-nome").val("");
        $(".js-categoria-fase-check").prop("checked", false);
        $(".js-categoria-form-titulo").text("Nova categoria");
        $(".js-categoria-submit-label").text("Criar categoria");
        $(".js-categoria-cancelar-edicao").addClass("d-none");
    }

    function carregarCategorias() {
        const pipelineId = pipelineIdAtual();
        $("#js-categoria-pipeline-id").val(pipelineId);

        return $.get(routes.categoriasIndex(), { pipeline_id: pipelineId })
            .done(function (response) {
                if (response.error) {
                    toast(response.message || "Erro ao carregar categorias.", "danger");
                    return;
                }

                const data = response.data || {};
                renderCategoriasLista(data.categorias || []);
                renderFasesCheckboxes(data.fases || [], []);
                resetFormCategoria();
            })
            .fail(function () {
                toast("Erro ao carregar categorias.", "danger");
            });
    }

    function abrirModalCategorias() {
        carregarCategorias().done(function () {
            $("#modalCategoriasFases").modal("show");
        });
    }

    function faseIdsSelecionadas() {
        const ids = [];
        $(".js-categoria-fase-check:checked").each(function () {
            ids.push($(this).val());
        });
        return ids;
    }

    function salvarCategoria(event) {
        event.preventDefault();

        const categoriaId = $("#js-categoria-id").val();
        const payload = {
            _token: csrfToken(),
            pipeline_id: $("#js-categoria-pipeline-id").val() || pipelineIdAtual(),
            nome: $(".js-categoria-nome").val(),
            fase_ids: faseIdsSelecionadas(),
        };

        if (!payload.nome || !payload.fase_ids.length) {
            toast("Informe o nome e selecione ao menos uma fase.", "warning");
            return;
        }

        const isEdit = !!categoriaId;
        if (isEdit) {
            payload._method = "PUT";
        }

        $.ajax({
            url: isEdit ? routes.categoriasUpdate(categoriaId) : routes.categoriasStore(),
            method: "POST",
            data: payload,
        })
            .done(function (response) {
                if (response.error) {
                    toast(response.message || "Erro ao salvar categoria.", "danger");
                    return;
                }
                toast(response.message || "Categoria salva.");
                carregarCategorias();
            })
            .fail(function (xhr) {
                const message =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Erro ao salvar categoria.";
                toast(message, "danger");
            });
    }

    function editarCategoria($btn) {
        const id = $btn.data("id");
        const nome = $btn.data("nome");
        let faseIds = $btn.attr("data-fase-ids");
        try {
            faseIds = JSON.parse(faseIds);
        } catch (e) {
            faseIds = [];
        }

        $("#js-categoria-id").val(id);
        $(".js-categoria-nome").val(nome);
        $(".js-categoria-fase-check").each(function () {
            $(this).prop("checked", faseIds.map(String).indexOf(String($(this).val())) !== -1);
        });
        $(".js-categoria-form-titulo").text("Editar categoria");
        $(".js-categoria-submit-label").text("Salvar alterações");
        $(".js-categoria-cancelar-edicao").removeClass("d-none");
    }

    let categoriaExclusaoId = null;

    function abrirModalExcluirCategoria(id, nome) {
        categoriaExclusaoId = id;
        const nomeSeguro = escapeHtml(nome || "");
        const mensagem = nomeSeguro
            ? `Tem certeza que deseja remover a categoria <strong>${nomeSeguro}</strong>?`
            : "Tem certeza que deseja remover esta categoria?";

        $(".js-confirma-excluir-categoria-mensagem").html(mensagem);
        $("#modalConfirmaExcluirCategoriaFase").modal({
            backdrop: false,
            keyboard: true,
            show: true,
        });
    }

    function confirmarExclusaoCategoria() {
        const id = categoriaExclusaoId;
        if (!id) {
            return;
        }

        $("#modalConfirmaExcluirCategoriaFase").modal("hide");

        $.ajax({
            url: routes.categoriasDestroy(id),
            method: "POST",
            data: {
                _token: csrfToken(),
                _method: "DELETE",
            },
        })
            .done(function (response) {
                if (response.error) {
                    toast(response.message || "Erro ao remover.", "danger");
                    return;
                }
                toast(response.message || "Categoria removida.");
                carregarCategorias();
            })
            .fail(function () {
                toast("Erro ao remover categoria.", "danger");
            })
            .always(function () {
                categoriaExclusaoId = null;
            });
    }

    $(document).on("click", ".js-abrir-modal-tempo-limite-fase", function (event) {
        event.preventDefault();
        abrirModalTempoLimite($(this).data("fase-id"), $(this).data("fase-nome"));
    });

    $(document).on("submit", "#js-form-tempo-limite-fase", salvarTempoLimite);
    $(document).on("click", ".js-remover-tempo-limite-fase", abrirModalRemoverTempoLimite);
    $(document).on("click", ".js-confirmar-exclusao-tempo-limite-fase", removerTempoLimite);

    $(document).on("hidden.bs.modal", "#modalConfirmaExcluirTempoLimiteFase", function () {
        if ($(".modal.show").length) {
            $("body").addClass("modal-open");
        }
    });

    $(document).on("click", ".js-abrir-modal-categorias-fases", function (event) {
        event.preventDefault();
        abrirModalCategorias();
    });

    $(document).on("submit", "#js-form-categoria-fase", salvarCategoria);
    $(document).on("click", ".js-categoria-cancelar-edicao", resetFormCategoria);
    $(document).on("click", ".js-editar-categoria", function () {
        editarCategoria($(this));
    });
    $(document).on("click", ".js-excluir-categoria", function () {
        abrirModalExcluirCategoria($(this).data("id"), $(this).data("nome"));
    });

    $(document).on("click", ".js-confirmar-exclusao-categoria-fase", confirmarExclusaoCategoria);

    $(document).on("hidden.bs.modal", "#modalConfirmaExcluirCategoriaFase", function () {
        categoriaExclusaoId = null;
        if ($(".modal.show").length) {
            $("body").addClass("modal-open");
        }
    });

    $(document).on("change", 'select[name="pipeline_id"]', function () {
        if ($("#modalCategoriasFases").hasClass("show")) {
            carregarCategorias();
        }
    });

    const badgesFaixaFunil = {
        abaixo: { classe: "badge-success", texto: "Abaixo do ideal" },
        quase: { classe: "badge-warning", texto: "Quase no ideal" },
        acima: { classe: "badge-danger", texto: "Acima do ideal" },
        sem_limite: { classe: "badge-secondary", texto: "Sem tempo ideal" },
    };

    function coletarFiltrosFunilPermanencia() {
        const $form = $("form.js-form-filtro-oportunidades").first();
        return {
            pipeline_id:
                $form.find('[name="pipeline_id"]').val() ||
                $("#kanban").data("pipeline") ||
                "",
            user_id: $form.find('[name="user_id"]').val() || "",
            canal: $form.find('[name="canal"]').val() || "",
            tag_id: $form.find('[name="tag_id"]').val() || "",
        };
    }

    function renderFunilPermanencia(payload) {
        const etapas = payload.etapas || [];
        const $body = $(".js-funil-permanencia-body");
        const total = payload.total_abertas || 0;
        $(".js-funil-permanencia-total").text(total);

        if (!etapas.length) {
            $body.html(
                '<div class="text-center text-muted py-4">Nenhuma fase encontrada para o filtro atual.</div>'
            );
            return;
        }

        let blocoWidth = 100;
        let html = "";

        etapas.forEach(function (etapa) {
            if (blocoWidth > 20) {
                blocoWidth -= 4;
            } else {
                blocoWidth = 24;
            }

            const corFase = etapa.cor || "#6c757d";
            const badge =
                badgesFaixaFunil[etapa.faixa] || badgesFaixaFunil.sem_limite;
            const limiteTxt = etapa.limite_formatado
                ? "Ideal " + etapa.limite_formatado
                : "Sem limite configurado";

            html +=
                '<div class="funil-block funil-permanencia-block">' +
                '<div class="funil clip funil-permanencia-clip" style="background-color:' +
                escapeHtml(corFase) +
                ";width:" +
                blocoWidth +
                '%;">' +
                '<div class="funil-permanencia-conteudo">' +
                '<div class="funil-permanencia-titulo">' +
                "<strong>" +
                escapeHtml(etapa.nome) +
                "</strong>" +
                '<span class="badge ' +
                badge.classe +
                ' funil-permanencia-badge">' +
                escapeHtml(badge.texto) +
                "</span>" +
                "</div>" +
                '<div class="funil-permanencia-detalhe">' +
                etapa.quantidade +
                " abertas · média " +
                escapeHtml(etapa.tempo_medio_formatado || "0s") +
                " · " +
                escapeHtml(limiteTxt) +
                "</div>" +
                '<div class="funil-permanencia-faixas">' +
                '<span class="badge badge-light">' +
                (etapa.abaixo || 0) +
                " abaixo</span> " +
                '<span class="badge badge-light">' +
                (etapa.quase || 0) +
                " quase</span> " +
                '<span class="badge badge-light">' +
                (etapa.acima || 0) +
                " acima</span>" +
                "</div>" +
                "</div>" +
                "</div>" +
                "</div>";
        });

        $body.html(html);
    }

    function carregarFunilPermanencia() {
        if (!window.urlFunilPermanencia) {
            return;
        }

        const $body = $(".js-funil-permanencia-body");
        $body.html(
            '<div class="text-center py-4"><i class="fas fa-spinner fa-spin fa-2x text-muted"></i></div>'
        );

        $.ajax({
            url: window.urlFunilPermanencia,
            type: "get",
            dataType: "json",
            data: coletarFiltrosFunilPermanencia(),
            success: function (res) {
                renderFunilPermanencia(res || {});
            },
            error: function () {
                $body.html(
                    '<div class="text-center text-danger py-4">Não foi possível carregar o funil de permanência.</div>'
                );
            },
        });
    }

    $(document).on("show.bs.modal", "#verFunilPermanencia", function () {
        carregarFunilPermanencia();
    });

    const COR_BADGE = {
        verde: "success",
        amarelo: "warning",
        vermelho: "danger",
        neutro: "secondary",
    };

    const CLASSES_COR_BADGE = [
        "oportunidade-permanencia-fase__badge--success",
        "oportunidade-permanencia-fase__badge--warning",
        "oportunidade-permanencia-fase__badge--danger",
        "oportunidade-permanencia-fase__badge--secondary",
    ];

    let tickerPermanenciaId = null;

    function formatarBadgePermanencia(segundos) {
        const total = Math.max(0, Math.floor(Number(segundos) || 0));

        if (total < 60) {
            return total + "s";
        }

        const minutos = Math.floor(total / 60);
        if (minutos < 60) {
            return minutos + "min";
        }

        const horas = Math.floor(minutos / 60);
        const minutosRestantes = minutos % 60;
        if (horas < 24) {
            if (minutosRestantes === 0) {
                return horas + "h";
            }

            return horas + "h " + minutosRestantes + "m";
        }

        const dias = Math.floor(horas / 24);
        const horasRestantes = horas % 24;
        if (dias < 365) {
            if (horasRestantes === 0) {
                return dias + "d";
            }

            return dias + "d " + horasRestantes + "h";
        }

        const anos = Math.floor(dias / 365);
        const diasRestantes = dias % 365;
        const rotuloAno = anos === 1 ? "1ano" : anos + "anos";

        if (diasRestantes === 0) {
            return rotuloAno;
        }

        return rotuloAno + " " + diasRestantes + "d";
    }

    function corBadgePermanencia(segundos, limiteSegundos) {
        const limite = Number(limiteSegundos);
        if (!limite || limite <= 0 || Number.isNaN(limite)) {
            return COR_BADGE.neutro;
        }

        const percentual = (segundos / limite) * 100;
        if (percentual >= 100) {
            return COR_BADGE.vermelho;
        }
        if (percentual >= 70) {
            return COR_BADGE.amarelo;
        }

        return COR_BADGE.verde;
    }

    function formatarTempoCompleto(segundos) {
        const total = Math.max(0, Math.floor(Number(segundos) || 0));
        const dias = Math.floor(total / 86400);
        const horas = Math.floor((total % 86400) / 3600);
        const minutos = Math.floor((total % 3600) / 60);
        const segs = total % 60;

        return dias + "d " + horas + "h " + minutos + "min " + segs + "s";
    }

    function atualizarTempoTotalLive() {
        const agora = Math.floor(Date.now() / 1000);

        document
            .querySelectorAll(".js-oportunidade-tempo-total[data-ativo='1']")
            .forEach(function (el) {
                const segundosBase = parseInt(el.getAttribute("data-segundos"), 10) || 0;
                const renderedAt = parseInt(el.getAttribute("data-rendered-at"), 10) || agora;
                const elapsed = segundosBase + Math.max(0, agora - renderedAt);
                const texto = formatarTempoCompleto(elapsed);

                if (el.textContent !== texto) {
                    el.textContent = texto;
                }
            });
    }

    function atualizarBadgesPermanenciaLive() {
        const agora = Math.floor(Date.now() / 1000);

        atualizarTempoTotalLive();

        document
            .querySelectorAll(".js-oportunidade-permanencia-badge[data-ativo='1']")
            .forEach(function (badge) {
                const segundosBase = parseInt(badge.getAttribute("data-segundos"), 10) || 0;
                const renderedAt = parseInt(badge.getAttribute("data-rendered-at"), 10) || agora;
                const limiteAttr = badge.getAttribute("data-limite");
                const limite =
                    limiteAttr === null || limiteAttr === ""
                        ? null
                        : parseInt(limiteAttr, 10);

                const elapsed = segundosBase + Math.max(0, agora - renderedAt);
                const texto = formatarBadgePermanencia(elapsed);
                const cor = corBadgePermanencia(elapsed, limite);
                const $texto = badge.querySelector(".js-oportunidade-permanencia-texto");

                if ($texto && $texto.textContent !== texto) {
                    $texto.textContent = texto;
                }

                const classeCor = "oportunidade-permanencia-fase__badge--" + cor;
                if (!badge.classList.contains(classeCor)) {
                    CLASSES_COR_BADGE.forEach(function (classe) {
                        badge.classList.remove(classe);
                    });
                    badge.classList.add(classeCor);
                }
            });
    }

    function iniciarTickerPermanencia() {
        if (tickerPermanenciaId !== null) {
            return;
        }

        atualizarBadgesPermanenciaLive();
        tickerPermanenciaId = window.setInterval(atualizarBadgesPermanenciaLive, 1000);
    }

    $(document)
        .off("eloca:kanban-cards-changed.permanenciaLive")
        .on("eloca:kanban-cards-changed.permanenciaLive", function () {
            atualizarBadgesPermanenciaLive();
        });

    $(function () {
        iniciarTickerPermanencia();
    });
})();
